import { BookOpen, Cake, Flame, Heart, Landmark, PawPrint, Sparkles, Star } from "lucide-react";
import { WishBox } from "./WishBox";

const ICONS = { cumple: Cake, aniversario: Heart, especial: Sparkles, yahrzeit: Flame, fiesta: Star, efemeride: BookOpen, historia: Landmark };

export function CalBadge({ calendar }) {
  if (!calendar) return null;
  const heb = calendar === "hebrew";
  return (
    <span className={`inline-flex items-center rounded-full px-2.5 py-0.5 text-[10px] font-semibold uppercase tracking-wider ${heb ? "bg-dusk/10 text-dusk" : "bg-amber-deep/10 text-amber-deep"}`}>
      {heb ? "Calendario hebreo" : "Calendario gregoriano"}
    </span>
  );
}

export function EventIcon({ ev, className = "w-5 h-5" }) {
  const Icon = ev.is_pet ? PawPrint : ICONS[ev.kind] || Star;
  return <Icon className={className} strokeWidth={1.6} />;
}

// Tarjeta grande pa' eventos familiares del día (cumples, aniversarios, iortzait).
export function TodayEventCard({ ev, me, index }) {
  const isMine = ev.person_id === me?.id || (ev.person_ids || []).includes(me?.id);
  const heading = ev.kind === "cumple"
    ? (isMine ? `Hoy es tu cumpleaños ${ev.years}` : `Hoy es el cumpleaños ${ev.years} de ${ev.title.replace(/^Cumpleaños \d+ de /, "")}`)
    : ev.title;
  return (
    <article data-testid={`today-event-${index}`} className="cal-rise rounded-3xl bg-cream border border-line p-5 sm:p-6 shadow-sm"
      style={{ animationDelay: `${120 + index * 80}ms` }}>
      <div className="flex items-start gap-4">
        <div className={`shrink-0 w-12 h-12 rounded-2xl flex items-center justify-center ${ev.kind === "yahrzeit" ? "bg-night text-candle" : "bg-amber-deep text-paper"}`}>
          <EventIcon ev={ev} />
        </div>
        <div className="min-w-0 flex-1">
          <h3 data-testid={`today-event-${index}-title`} className="font-display text-cocoa text-2xl sm:text-[28px] leading-tight">{heading}</h3>
          <p className="font-serif italic text-cocoa-soft text-base mt-1">{ev.detail}</p>
          {ev.branch && <p className="mt-1.5 text-[11px] uppercase tracking-wider text-cocoa-soft/80">{ev.branch}</p>}
        </div>
      </div>
      {ev.wish_key && <WishBox wishKey={ev.wish_key} initial={ev.wishes || []} isMine={isMine} testId={`wishbox-${index}`} />}
    </article>
  );
}

// Fila compacta pa' listas (próximos días, mes, efemérides).
export function EventRow({ ev, testId }) {
  return (
    <div data-testid={testId} className="flex items-start gap-3 py-2.5">
      <div className={`shrink-0 w-8 h-8 rounded-xl flex items-center justify-center ${["fiesta", "efemeride", "historia", "yahrzeit"].includes(ev.kind) ? "bg-night/90 text-candle" : "bg-amber-deep/10 text-amber-deep"}`}>
        <EventIcon ev={ev} className="w-4 h-4" />
      </div>
      <div className="min-w-0">
        <p className="text-sm font-medium text-cocoa leading-snug">{ev.title}</p>
        <p className="text-xs text-cocoa-soft/90 leading-snug">{ev.detail}</p>
      </div>
    </div>
  );
}
